import { render, staticRenderFns } from "./RootContent.vue?vue&type=template&id=cf1f483e&"
import script from "./RootContent.vue?vue&type=script&lang=js&"
export * from "./RootContent.vue?vue&type=script&lang=js&"
import style0 from "./RootContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports